import React from 'react';
import { FaUser } from 'react-icons/fa';

const BuyerLedgerClientConfiguration = ({ form, errors, onChange }) => (
  <div className="card border-0 shadow-sm mb-4 blc-card blc-card-primary">
    <div className="card-header bg-white border-0 pb-0">
      <h5 className="mb-0 blc-card-title blc-card-title-primary">
        <FaUser className="me-2" />
        Client Configuration
      </h5>
    </div>
    <div className="card-body">
      <div className="row">
        <div className="col-lg-6 mb-3">
          <label className="form-label fw-semibold text-dark">
            Client Type <span className="text-danger">*</span>
          </label>
          <div className="d-flex gap-3">
            <div className="form-check">
              <input
                className="form-check-input"
                type="radio"
                name="clientType"
                id="clientDomestic"
                value="Domestic"
                checked={form.clientType === 'Domestic'}
                onChange={onChange}
              />
              <label className="form-check-label" htmlFor="clientDomestic">
                Domestic
              </label>
            </div>
            <div className="form-check">
              <input
                className="form-check-input"
                type="radio"
                name="clientType"
                id="clientExport"
                value="Export"
                checked={form.clientType === 'Export'}
                onChange={onChange}
              />
              <label className="form-check-label" htmlFor="clientExport">
                Export
              </label>
            </div>
          </div>
        </div>
        <div className="col-lg-6 mb-3">
          <label className="form-label fw-semibold text-dark">
            Client Code <span className="text-danger">*</span>
          </label>
          <input
            name="clientId"
            value={form.clientId}
            onChange={onChange}
            readOnly={!!form._id}
            className={`form-control form-control-lg blc-input ${form._id ? 'bg-light' : ''} ${errors.clientId ? 'is-invalid' : ''}`}
            placeholder="Enter Client Code"
            title={form._id ? 'Client code cannot be changed after save' : ''}
          />
          {form._id && <small className="text-muted">Client code cannot be modified once saved.</small>}
          {errors.clientId && <div className="invalid-feedback d-block">{errors.clientId}</div>}
        </div>
      </div>
      <div className="row">
        <div className="col-lg-12 mb-3">
          <label className="form-label fw-semibold text-dark">
            Client Name <span className="text-danger">*</span>
          </label>
          <input
            name="name"
            value={form.name}
            onChange={onChange}
            className={`form-control form-control-lg blc-input ${errors.name ? 'is-invalid' : ''}`}
            placeholder="Enter client/buyer name"
          />
          {errors.name && <div className="invalid-feedback d-block">{errors.name}</div>}
        </div>
      </div>
    </div>
  </div>
);

export default BuyerLedgerClientConfiguration;
